export class Team
{
	teamId: number;
	teamUserAPIList: any;
}
